import { newsletter } from "../../../api/newsletter.api";

export const Newsletter = {
  state: {
    newsletter: {
      name: null,
      email: null,
    },
    success: false,
  },

  mutations: {
    SET_FORM_DATA(state, { name, email }) {
      state.newsletter.name = name;
      state.newsletter.email = email;
    },
  },

  actions: {
    async submitForm({ state, commit }, payload) {
      try {
        const { data } = await newsletter(payload);
        state.success = data.success;
        commit("SET_FORM_DATA", data);
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {},
  namespaced: true,
};
